module.exports = __webpack_public_path__ + "img/infograph_3.61182599.png";